"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sender = void 0;
var request_1 = require("../../../util/request");
var base_channel_interface_1 = require("../../base-channel/base-channel.interface");
var base_1 = require("../../../base");
var interface_1 = require("../../../interface");
var Sender = /** @class */ (function () {
    function Sender(dependency) {
        this.dependency = dependency;
        this.requestId = 0; // TODO requestId 是每次初始化都是 0，还是销毁实例的时候记录下当前值，继续沿用?
        this.retryTimerMap = new Map();
    }
    Sender.prototype.dispose = function () {
        this.clearAllRetryTimer();
    };
    /**
     * 发送消息
     * @param message
     * @param requestBaseOptions
     */
    Sender.prototype.sendMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var requestConfig, commitResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestConfig = this.createRequestConfig(message);
                        return [4 /*yield*/, this.commitMessage(message, requestConfig)];
                    case 1:
                        commitResult = _a.sent();
                        return [4 /*yield*/, this.handleCommitResult(message, commitResult)];
                    case 2: 
                    // 3、处理返回消息
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Sender.prototype.clearAllRetryTimer = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.retryTimerMap.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var timer = _c.value;
                clearTimeout(timer);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.retryTimerMap.clear();
    };
    Sender.prototype.createRequestConfig = function (message) {
        return {
            timeout: message.timeout,
            maxRetry: interface_1.DEFAULT_RETRY_COUNTS,
            contentType: base_1.ContentTypeValue.JSON,
        };
    };
    Sender.prototype.commitMessage = function (message, requestConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, token, sid, routeKey, commitRequestUrl, content;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.dependency.getServerParams(), token = _a.token, sid = _a.sid, routeKey = _a.routeKey;
                        commitRequestUrl = "/websocket/save?routeKey=" + routeKey;
                        content = {
                            routeKey: routeKey,
                            token: token,
                            sid: sid,
                            syncCommit: message.syncCommit,
                            requestId: this.requestId,
                            head: message.postData.head,
                            body: message.postData.body,
                        };
                        this.requestId += 1;
                        return [4 /*yield*/, new request_1.Request().sendRequest(commitRequestUrl, base_channel_interface_1.Method.POST, content, requestConfig)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    /**
     * 验证和处理接口返回的数据，分别触发 onError/onsend/onSendAccept
     * @param commitResult
     * @param sendMessage
     */
    Sender.prototype.handleCommitResult = function (message, commitResult) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var responseData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        responseData = (_a = commitResult.data) === null || _a === void 0 ? void 0 : _a.data;
                        if (!(commitResult.error || !responseData)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.retrySendMessage(message)];
                    case 1: 
                    // 网络异常处理：超时 4xx 5xx 等
                    return [2 /*return*/, _b.sent()];
                    case 2: return [2 /*return*/, responseData];
                }
            });
        });
    };
    Sender.prototype.clearMessageRetryTimer = function (message) {
        if (this.retryTimerMap.has(message.taskId)) {
            clearTimeout(this.retryTimerMap.get(message.taskId));
            this.retryTimerMap.delete(message.taskId);
        }
    };
    Sender.prototype.retrySendMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var delayDuration;
            var _this = this;
            return __generator(this, function (_a) {
                this.clearMessageRetryTimer(message);
                if (!this.dependency.isConnected()) {
                    // 当前正在登录或者重连中，等待重连后恢复发送，此时无需 send
                    this.dependency.onMessageWaiting(message);
                    message.retryCount = 0;
                    return [2 /*return*/];
                }
                delayDuration = this.getDelayDuration(message.retryCount);
                return [2 /*return*/, new Promise(function (resolve) {
                        var retryTimer = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var result;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        this.dependency.onMessageSending(message);
                                        return [4 /*yield*/, this.sendMessage(message)];
                                    case 1:
                                        result = _a.sent();
                                        resolve(result);
                                        return [2 /*return*/];
                                }
                            });
                        }); }, delayDuration);
                        _this.retryTimerMap.set(message.taskId, retryTimer);
                    })];
            });
        });
    };
    Sender.prototype.getDelayDuration = function (count) {
        return Math.min(count * 2, 30) * 1000;
    };
    return Sender;
}());
exports.Sender = Sender;
